import * as React from 'react'

import {emptyArray, emptyObject} from '../../../../../../../utils/empty'
import type {KeyValue} from '../../../../../../../utils/object'
import {objectKeys} from '../../../../../../../utils/object'

export type SelectionState = KeyValue<string, boolean>

export function useSelectionState(): [
  SelectionState,
  ReadonlyArray<string>,
  (id: string) => void,
  (state: SelectionState) => void,
] {
  const [state, setState] = React.useState<SelectionState>(emptyObject)
  const selectedIds = React.useMemo(
    () => objectKeys(state).reduce((ids, id) => (state[id] ? [...ids, id] : ids), emptyArray),
    [state],
  )
  const toggleItemState = React.useCallback(
    (id: string) => {
      const selection = state[id]
      setState({...state, [id]: selection == null ? true : !selection})
    },
    [state],
  )

  return [state, selectedIds, toggleItemState, setState]
}
